module.exports = __webpack_public_path__ + "media/images/icon-checkbox-off2-490c28b4c1073fd782827703664154b0.svg";